import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./assests/css/Style.css";
import "./assests/css/font.css";
import "leaflet/dist/leaflet.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
